import React, { useRef, useEffect, useState } from 'react';

// import paymentService  from './service';
import { cardToken, saveCard } from '../../../../reducers/feed/feed.actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import API from '../../../../API';
import {
    ADD_CARD
} from '../../../../constants/routes';
import { CommentDolarIcon, CanselIcon, CardFail } from '../../../../components/Icons';

export const generatePfToken = async () => {
    const { data } = await API.post('/payments/pf-token')
    return data
}

export const getPaymentMethods = async () => {
    const { data } = await API.get('/payments/payment-methods')
    return data
}

const getPaymentController = ({ token, onError, onValid, setupComplete, onCardType }) => ({
    token,
    onFieldEventHandler: {
        onError,
        onBlur: () => { },
        onFocus: () => { },
        onType: onCardType,
        setupComplete,
        onValid
    },
    style: {
        "#ccn": { "color": 'white', "height": "40px", "background-color": "transparent!important" },
        "#exp": { "color": 'white', "height": "40px", "background-color": "transparent!important" },
        "#cvv": { "color": 'white', },
        "::placeholder": { "color": "#3D4052" },
        ".invalid": { "color": "red" },
    },

    ccnPlaceHolder: "xxxx xxxx xxxx xxxx",
    cvvPlaceHolder: "CVV",
    expPlaceHolder: "MM / YY"
})


const usePayment = () => {
    const [error, setError] = React.useState({ ccn: '' })
    const [pfToken, setPfToken] = React.useState({})
    const [bluesnapResponse, setBluesnapResponse] = React.useState({})
    const [cardType, setCardType] = React.useState('')
    const [loading, setLoading] = React.useState(false)
    const dispatch = useDispatch();
    const history = useHistory();
    const [paymentLoading, setPaymentLoading] = React.useState(false)

    const [errorCard, setErrorCard] = useState(false);
    const unsupportedCardType = cardType === 'JCB' || cardType === 'DISCOVER' || cardType === 'UNKNOWN'
    
    useEffect(() => {
        // const script = document.createElement('script');
        // process?.env.NODE_ENV == 'development' ? script.src = "https://sandbox.bluesnap.com/web-sdk/4/bluesnap.js" : script.src = "https://ws.bluesnap.com/web-sdk/4/bluesnap.js"
        // script.async = true;

        // document.body.appendChild(script);
        // return () => {
        //     document.body.removeChild(script);
        // }
        console.log(history.location.state)
    }, []);
    const shouldSubmit = React.useMemo(() => {
        return !['ccn', 'cvv', 'exp'].map((el) => !error[el] && typeof error[el] === 'boolean').includes(false)
    }, [error])
    const errorCardHandler = () => {
        if (errorCard) {
            return (
                <div className="card-popup-wrapper">

                    <div className=" declined-card">
                        <h2>Card declined</h2>
                        <div>
                            <button onClick={() => history.push(ADD_CARD)}>Cancel</button>
                            <button onClick={() => window.location.reload()}>Add card</button>

                        </div>

                    </div>
                </div>
            )
        }
    }
    const onError = React.useCallback(async (name, code, message) => {
        setError(state => ({ ...state, [name]: message }))
        if (code === 14040) {
            const data = await generatePfToken()
            setPfToken(data.token)
        }
    }, [])

    const onCardType = React.useCallback((_tagId, newCardType) => {
        setCardType(newCardType)
    }, [setCardType])

    const initPaymentController = React.useCallback(async () => {
        try {
            setLoading(true)

            setPaymentLoading(true)

            dispatch(cardToken()).then((resp) => {

                setPfToken(resp)

                const controller = getPaymentController({
                    token: resp.hosted_payment_fields_token,
                    onError,
                    onValid: (name) => setError(state => ({ ...state, [name]: false })),
                    setupComplete: () => setPaymentLoading(false),
                    onCardType
                })
                window.bluesnap.hostedPaymentFieldsCreate(controller)
            });

        } finally {
            setLoading(false)
        }
    }, [onError, onCardType])



    const submitPaymentInfo = () => {
        const promise1 = new Promise((resolve, reject) => {
            try {

                window.bluesnap.hostedPaymentFieldsSubmitData(cb => resolve(cb))
            } catch (err) {
                reject(err)
            }
        })
        promise1.then((value) => {
            if (unsupportedCardType) {
                    setErrorCard(true)     
            }else{
            setPaymentLoading(true)
            dispatch(saveCard(pfToken.hosted_payment_fields_token)).then(resp => {
                if (history.location.state?.user != undefined) {
                    setPaymentLoading(false)
                    history.push({ pathname: `u/${history.location.state.user.id}/${history.location.state.user.nickname}`, state: { openTip: true, tipPayment :history.location.state?.tipFlow,tipId:history.location.state?.tipId ,personalTip:history.location.state?.personalTipFlow } });

                }
                else {
                    setPaymentLoading(false)

                    history.push(ADD_CARD);
                }
            })
                .catch(err => {


                    setErrorCard(true)
                    setPaymentLoading(false)
                })}

        });

    }
    return {
        initPaymentController,
        submitPaymentInfo,
        errors: error,
        errorCard,
        shouldSubmit,
        pfToken,
        loading,
        setLoading, paymentLoading,
        cardType, errorCardHandler
    }
}

export default usePayment

